export enum ICON_TYPES {
    GALERIA = 'gridicons:camera',
    FLECHA_IZQ = 'mingcute:arrows-left-fill',
    FLECHA_DER = 'mingcute:arrows-right-fill',
    TEAM = 'ri:team-fill',
    SERVICIO = 'fluent-mdl2:c-r-m-services',
    ACTIVIDADES = 'fluent-mdl2:event-to-do-logo',
    DONACION = 'mdi:donation-outline',
    LACROSSE = 'fluent-emoji-high-contrast:lacrosse',
    CALENDARIO = 'ion:calendar',
    TRIANGULO = 'tabler:triangle-filled',
    RESPONSABILIDAD = 'tdesign:education-filled',
    AUTOCUIDADO = 'fluent-mdl2:party-leader',
    AMISTAD = 'carbon:friendship',
    EMPODERAMIENTO = 'game-icons:swords-power',
    PERTENENCIA = 'fa:group',
    MENU = 'mingcute:menu-fill'
}